'use strict';

var arrayLikeToArray = require('./arrayLikeToArray.js');

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}

module.exports = _arrayWithoutHoles;
